// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".power-maintain[data-v-3f6ffd36]  .el-tabs__header {\n  margin-bottom: 0;\n  border-bottom: none;\n}\n.permiss-head[data-v-3f6ffd36] {\n  padding: 16px 0;\n  margin-bottom: 8px;\n  margin-top: -8px;\n}\n.permiss-head span[data-v-3f6ffd36] {\n  padding-right: 40px;\n}", ""]);
// Exports
module.exports = exports;
